import React from 'react';

// Stripe shield with checkmark
const StripeBadge = () => (
  <div className="flex items-center gap-2">
    <svg viewBox="0 0 24 28" width="28" height="32" aria-label="Stripe shield">
      <path
        d="M12 0 L24 6 V14 C24 21 18 27 12 28 C6 27 0 21 0 14 V6 Z"
        fill="#32325D"
      />
      <path
        d="M7 14 L10.5 17.5 L17 11"
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
    <div className="flex flex-col leading-none">
      <span className="text-[10px] tracking-wide" style={{ color: '#32325D' }}>Powered by</span>
      <span className="text-[18px] font-bold italic mt-0.5" style={{ color: '#32325D', letterSpacing: '-0.02em' }}>
        stripe
      </span>
    </div>
  </div>
);

const VisaLogo = () => (
  <div className="h-8 px-3 flex items-center" style={{ backgroundColor: '#1A1F71', borderRadius: '4px' }}>
    <span
      className="font-extrabold italic text-white text-[16px] leading-none tracking-tight"
      style={{ fontFamily: 'Arial, Helvetica, sans-serif' }}
    >
      VISA
    </span>
  </div>
);

const MastercardLogo = () => (
  <div className="h-8 px-3 flex items-center gap-1" style={{ backgroundColor: '#FFFFFF', border: '1px solid #e5e5e5', borderRadius: '4px' }}>
    <div className="relative w-9 h-6">
      <span className="absolute left-0 top-0 w-6 h-6 rounded-full" style={{ backgroundColor: '#EB001B' }} />
      <span className="absolute right-0 top-0 w-6 h-6 rounded-full" style={{ backgroundColor: '#F79E1B', mixBlendMode: 'multiply' }} />
    </div>
    <span
      className="text-[10px] font-bold leading-none"
      style={{ color: '#1a1a1a', fontFamily: 'Arial, sans-serif' }}
    >
      MasterCard
    </span>
  </div>
);

const AmexLogo = () => (
  <div className="h-8 px-3 flex items-center" style={{ backgroundColor: '#2671B9', borderRadius: '4px' }}>
    <div className="flex flex-col items-center leading-none">
      <span className="text-white font-extrabold text-[9px]" style={{ fontFamily: 'Arial, sans-serif', letterSpacing: '0.5px' }}>
        AMERICAN
      </span>
      <span className="text-white font-extrabold text-[9px] mt-0.5" style={{ fontFamily: 'Arial, sans-serif', letterSpacing: '0.5px' }}>
        EXPRESS
      </span>
    </div>
  </div>
);

const PaymentIcons = () => {
  return (
    <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-3">
      <StripeBadge />
      <div className="flex items-center gap-2">
        <VisaLogo />
        <MastercardLogo />
        <AmexLogo />
      </div>
    </div>
  );
};

export default PaymentIcons;
